(function() {
  const style = document.createElement('style');
  style.textContent = `
    option.rapi-unavailable {
      text-decoration: line-through !important;
      text-decoration-thickness: 2px !important;
      text-decoration-color: #ff0000 !important;
      color: #999 !important;
      background-color: #f5f5f5;
    }
  `;
  document.head.appendChild(style);

  const localeMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-zA-Z]{2,4})?)(?=\/|$)/i);
  const localePrefix = localeMatch ? `/${localeMatch[1]}` : '';
  const cache = new Map();

  async function fetchVariants(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const url = `${localePrefix}/products/${handle}.js`;
    const promise = fetch(url)
      .then(r => r.ok ? r.json() : null)
      .then(p => p ? p.variants : [])
      .catch(() => []);
    cache.set(handle, promise);
    return promise;
  }

  function getProductHandle() {
    const urlMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (urlMatch) return urlMatch[1];
    const og = document.querySelector('meta[property="og:url"]')?.content;
    if (og) {
      const m = og.match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }

  async function updateSelect(select) {
    const bundleVariant = select.closest('.rapi-bundles__bar-variant');
    if (!bundleVariant) return;

    let handle = getProductHandle();
    if (!handle) {
      const dataHandle = bundleVariant.closest('[data-product-handle], [data-handle]');
      if (dataHandle) handle = dataHandle.dataset.productHandle || dataHandle.dataset.handle;
    }
    if (!handle) return;

    const variants = await fetchVariants(handle);
    if (!variants.length) return;

    const wrapper = select.closest('.rapi-bundles__bar-variant-selects');
    const currentOptions = [];
    if (wrapper) {
      wrapper.querySelectorAll('select').forEach(s => {
        if (s !== select) currentOptions.push(s.value);
      });
    }
    const currentIndex = Array.from(wrapper?.querySelectorAll('select') || []).indexOf(select);
    if (currentIndex === -1) return;

    Array.from(select.options).forEach(option => {
      const value = option.value;
      const available = variants.some(v => {
        if (!v.available) return false;
        for (let i = 0; i < v.options.length; i++) {
          if (i === currentIndex) {
            if (v.options[i] !== value) return false;
          } else if (currentOptions[i] !== undefined && v.options[i] !== currentOptions[i]) {
            return false;
          }
        }
        return true;
      });
      if (!available) {
        option.classList.add('rapi-unavailable');
        option.disabled = true;
      } else {
        option.classList.remove('rapi-unavailable');
        option.disabled = false;
      }
    });
  }

  // Fonction avec délai pour forcer la mise à jour avant l'ouverture du picker iOS
  function scheduleUpdate(select) {
    setTimeout(() => updateSelect(select), 100);
  }

  function initSelect(select) {
    if (select._listening) return;
    select._listening = true;
    updateSelect(select);
    select.addEventListener('change', () => updateSelect(select));
    // Événements pour iOS : déclenche la mise à jour juste avant que le picker ne s'ouvre
    select.addEventListener('focus', () => scheduleUpdate(select));
    select.addEventListener('touchstart', () => scheduleUpdate(select), { passive: true });
    select.addEventListener('click', () => scheduleUpdate(select));
    // Pour les anciennes versions d'iOS
    select.addEventListener('mousedown', () => scheduleUpdate(select));
  }

  function initSelects() {
    document.querySelectorAll('.rapi-bundles__bar-variant-select').forEach(initSelect);
  }

  const observer = new MutationObserver(() => initSelects());
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSelects);
  } else {
    initSelects();
  }
})();